import {
  Button,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import GenericModal from "../../Modal/GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import { isMobile } from "../../Utils/utils";
import HistoryComponent from "../HistoryComponent";
import { StatusModel, VINRequestModel } from "../../Models/Models";
type VINRequestModalProps = {
  open: boolean;
  selected: VINRequestModel | null;
  vinRequestStatus: number | undefined;
  setVinRequestStatus: (status: number) => void;
  onClose: () => void;
  onSave: (id: number | undefined) => void;
  cacheContext: any;
};

export default function VINRequestModal(props: VINRequestModalProps) {
  const {
    open,
    selected,
    vinRequestStatus,
    setVinRequestStatus,
    onClose,
    onSave,
    cacheContext,
  } = props;

  if (!selected) return null;

  return (
    <GenericModal
        open={open}
        notes={{ entityId: selected?.id, entity: "vinRequest" }}
        onClose={onClose}
        title={Vocabulary.vinRequest}
        buttons={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                onSave(selected?.id);
              }}
            >
              {Vocabulary.save}
            </Button>
          </div>
        }
      >
        <h2>
          {selected?.vehicle?.brand_r?.nume || ""}{" "}
          {selected?.vehicle?.model_r?.nume || ""}
        </h2>
        {Vocabulary.vin}: {selected?.vin}
        <br />
        <br />
        <Divider />
        <br />
        <Typography sx={{ fontSize: 20 }}>
          {Vocabulary.phone}: <strong>{selected?.phone}</strong>
        </Typography>
        <br />
        <Typography
          style={{
            display: "flex",
            justifyContent: "center ",
            padding: "10px 0",
            fontSize: "1rem",
          }}
        >
          <strong>{Vocabulary.status}</strong>
        </Typography>
        <ToggleButtonGroup
          sx={{
            "& .MuiToggleButton-root": {
             
              "&.Mui-selected": {
                backgroundColor: "rgba(255, 102, 51, 0.12)",
                color: "#FF6633",
              },
            },
          }}
          value={vinRequestStatus}
          exclusive
          orientation={isMobile() ? "vertical" : "horizontal"}
          aria-label="text alignment"
          style={{ display: "flex", justifyContent: "center" }}
        >
          {cacheContext?.cache?.clientMessagesStatus?.map(
            (statusOption: StatusModel) => {
              return (
                <ToggleButton
                  key={statusOption.id}
                  value={statusOption.id || 0}
                  onClick={(_: any) => {
                    setVinRequestStatus(statusOption.id || 0);
                  }}
                >
                  {statusOption.nume}
                </ToggleButton>
              );
            }
          )}
        </ToggleButtonGroup>
        {selected?.logs?.length ? (
          <HistoryComponent
            logs={selected?.logs}
            type={Vocabulary.vinRequest}
            firstAllocMessage={Vocabulary.vinRequestAllocMessage}
            firstTimeStatusSetMessage={Vocabulary.vinRequestStatusSetMessage}
            createdMessage={Vocabulary.vinRequestCreatedMessage}
            statusChangedMessage={Vocabulary.vinRequestStatusChangedMessage}
          />
        ) : null}
      </GenericModal>
  );
}
